import 'svelte/internal/disclose-version';

Stars[$.FILENAME] = 'src/components/Stars.svelte';

import * as $ from 'svelte/internal/client';
import { starBuckets, formatRating } from "../lib/format.js";

var root = $.add_locations($.from_svg(`<svg viewBox="0 0 20 20"><defs><linearGradient><stop offset="50%" stop-color="var(--mustard)"></stop><stop offset="50%" stop-color="transparent"></stop></linearGradient></defs><path d="M10 1.6l2.5 5.2 5.7.8-4.1 4 1 5.7L10 14.6 4.9 17.3l1-5.7-4.1-4 5.7-.8z" stroke="var(--mustard)" stroke-width="1.2" stroke-linejoin="round"></path></svg>`), Stars[$.FILENAME], [
	[11, 6, [[12, 8, [[13, 10, [[14, 12], [15, 12]]]]], [18, 8]]]
]);

var root_1 = $.add_locations($.from_html(`<em class="svelte-1334gup"> </em>`), Stars[$.FILENAME], [[30, 24]]);
var root_2 = $.add_locations($.from_html(`<b class="svelte-1334gup"> </b> <!>`, 1), Stars[$.FILENAME], [[29, 4]]);
var root_3 = $.add_locations($.from_html(`<span class="stars svelte-1334gup"><span class="glyphs svelte-1334gup" aria-hidden="true"></span> <!></span>`), Stars[$.FILENAME], [[8, 0, [[9, 2]]]]);

const $$css = {
	hash: 'svelte-1334gup',
	code: '\n  .stars.svelte-1334gup {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.86rem;\n    color: var(--ink-soft);\n  }\n  .glyphs.svelte-1334gup { display: inline-flex; gap: 1px; }\n  svg.svelte-1334gup { width: var(--size); height: var(--size); display: block; }\n  b.svelte-1334gup { color: var(--ink); font-weight: 600; }\n  em.svelte-1334gup { font-style: normal; color: var(--ink-faint); }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Stars($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Stars);
	$.append_styles($$anchor, $$css);

	let value = $.prop($$props, 'value', 3, 0),
		count = $.prop($$props, 'count', 3, null),
		size = $.prop($$props, 'size', 3, 18),
		showNumber = $.prop($$props, 'showNumber', 3, true);

	const buckets = $.tag($.derived(() => starBuckets(value())), 'buckets');
	var $$exports = { ...$.legacy_api() };
	var span = root_3();
	var span_1 = $.child(span);

	$.add_svelte_meta(
		() => $.each(span_1, 21, () => $.get(buckets), $.index, ($$anchor, bucket, i) => {
			var svg = root();
			var defs = $.child(svg);
			var linearGradient = $.child(defs);

			$.set_attribute(linearGradient, 'id', `half-${i}`);
			$.reset(defs);

			var path = $.sibling(defs);

			$.reset(svg);

			$.template_effect(() => {
				$.set_class(svg, 0, $.clsx($.get(bucket)), 'svelte-1334gup');

				$.set_attribute(path, 'fill', $.strict_equals($.get(bucket), "full")
					? "var(--mustard)"
					: $.strict_equals($.get(bucket), "half") ? `url(#half-${i})` : "none");
			});

			$.append($$anchor, svg);
		}),
		'each',
		Stars,
		10,
		4
	);

	$.reset(span_1);

	var node = $.sibling(span_1, 2);

	{
		var consequent_1 = ($$anchor) => {
			var fragment = root_2();
			var b = $.first_child(fragment);
			var text = $.child(b, true);

			$.reset(b);

			var node_1 = $.sibling(b, 2);

			{
				var consequent = ($$anchor) => {
					var em = root_1();
					var text_1 = $.child(em);

					$.reset(em);
					$.template_effect(() => $.set_text(text_1, `(${count() ?? ''})`));
					$.append($$anchor, em);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if ($.strict_equals(count(), null, false)) $$render(consequent);
					}),
					'if',
					Stars,
					30,
					4
				);
			}

			$.template_effect(($0) => $.set_text(text, $0), [() => formatRating(value())]);
			$.append($$anchor, fragment);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (showNumber()) $$render(consequent_1);
			}),
			'if',
			Stars,
			28,
			2
		);
	}

	$.reset(span);

	$.template_effect(
		($0) => {
			$.set_style(span, `--size: ${size() ?? ''}px`);
			$.set_attribute(span, 'aria-label', $0);
		},
		[
			() => count()
				? `${formatRating(value())} out of 5, ${count()} reviews`
				: `${formatRating(value())} out of 5`
		]
	);

	$.append($$anchor, span);

	return $.pop($$exports);
}